import React from 'react'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { ConciergeChat } from './ConciergeChat'
import { ChatProvider } from './ChatContext'
import {
  BasketProvider,
  FavouritesProvider,
} from '@moonpig/web-shared-products'

export const ConciergeChatModal = () => {
  const isSearchConciergeExperimentEnabled = useExperiment('search-concierge', {
    fallback: false,
  })

  if (!isSearchConciergeExperimentEnabled) {
    return null
  }

  return (
    <FavouritesProvider location="ai-mode">
      <BasketProvider>
        <ChatProvider>
          <ConciergeChat />
        </ChatProvider>
      </BasketProvider>
    </FavouritesProvider>
  )
}
